import enApp from "./en/app.json";
import enCommon from "./en/common.json";
import enLanding from "./en/landing.json";
import { TLocaleBundle } from "./resources.models";
import ukApp from "./uk/app.json";
import ukCommon from "./uk/common.json";
import ukLanding from "./uk/landing.json";

/** Copy both apps render: badges, payment methods, the receipt tape. */
export const COMMON_RESOURCES: TLocaleBundle = { uk: ukCommon, en: enCommon };

export const LANDING_RESOURCES: TLocaleBundle = {
  uk: ukLanding,
  en: enLanding,
};

export const APP_RESOURCES: TLocaleBundle = { uk: ukApp, en: enApp };
